<template>
  <div class="nfc-video-container">
    <!-- 搜索区域 -->
    <div class="search-box">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="视频名称">
          <el-input v-model="searchForm.name" placeholder="请输入视频名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <el-button type="success" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="table-box">
      <el-table :data="tableData" border stripe v-loading="loading" style="width: 100%">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column prop="name" label="视频名称" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="modeId" label="微信MODEL_ID" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="urlScheme" label="NFC_URL" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="url" label="视频地址" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <a :href="scope.row.url" target="_blank" style="color: #409EFF">{{ scope.row.url }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="qrcodeUrl" label="小程序二维码" width="120" align="center">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.qrcodeUrl"
              style="width: 50px; height: 50px"
              :src="prefix + scope.row.qrcodeUrl"
              :preview-src-list="[prefix + scope.row.qrcodeUrl]"
              fit="cover">
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color: #F56C6C" v-if="!scope.row.modeId" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="700px" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="140px">
        <el-form-item label="视频名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入视频名称"></el-input>
        </el-form-item>
        <el-form-item label="微信MODEL_ID" prop="modeId" v-if="!form.id">
          <el-input v-model="form.modeId" placeholder="请输入微信设备模块ID"></el-input>
        </el-form-item>
        <el-form-item label="设备SN" prop="sn" v-if="!form.id">
          <el-input v-model="form.sn" placeholder="请输入设备SN"></el-input>
        </el-form-item>
        <el-form-item label="视频文件" prop="url">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            :on-success="handleVideoSuccess"
            :on-error="handleVideoError"
            :before-upload="beforeVideoUpload"
            :show-file-list="false"
            :headers="uploadHeaders"
            accept="video/*,image/gif">
            <el-button size="small" type="primary" :loading="videoUploading">
              {{ videoUploading ? '上传中...' : '点击上传视频' }}
            </el-button>
            <div slot="tip" class="el-upload__tip">支持mp4、avi、mov等视频格式或gif动图，文件大小不超过100MB</div>
          </el-upload>
          <div v-if="form.url" style="margin-top: 10px">
            <video :src="form.url" controls style="width: 100%; max-width: 400px; max-height: 300px" v-if="!form.url.endsWith('.gif')"></video>
            <el-image
                v-else
                style="width: 400px;"
                :src="form.url"
                :preview-src-list="[form.url]"
                fit="contain">
            </el-image>
            <el-button type="text" size="small" style="color: #F56C6C; margin-left: 10px" @click="removeVideo">删除视频</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'nfcVideo',
  data() {
    return {
      prefix: this.$http.defaults.baseURL,
      // 搜索表单
      searchForm: {
        name: ''
      },
      // 表格数据
      tableData: [],
      loading: false,
      // 弹窗
      dialogVisible: false,
      dialogTitle: '新增NFC视频',
      isEdit: false,
      submitLoading: false,
      // 上传相关
      uploadUrl: this.$http.defaults.baseURL + 'nfc/video/upload',
      uploadHeaders: {
        // 如果需要token，在这里添加
        // 'Authorization': 'Bearer ' + localStorage.getItem('token')
      },
      videoUploading: false,
      // 表单
      form: {
        id: null,
        name: '',
        modeId: '',
        url: '',
        sn: ''
      },
      // 表单验证规则
      rules: {
        modeId: [
          { required: true, message: '请输入微信设备模块ID', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入视频名称', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请上传视频文件', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表数据
    async getList() {
      this.loading = true
      try {
        const params = {
          ...this.searchForm
        }
        // 移除空值参数
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })
        const res = await this.$http.get('/nfc/video/list', { params })
        if (res.data.code === 200) {
          this.tableData = res.data.data.list || []
        } else {
          this.$message.error(res.data.message || '获取列表失败')
        }
      } catch (error) {
        console.error('获取列表失败:', error)
        this.$message.error('获取列表失败')
      } finally {
        this.loading = false
      }
    },
    // 搜索
    handleSearch() {
      this.getList()
    },
    // 重置
    handleReset() {
      this.searchForm = {
        name: ''
      }
      this.getList()
    },
    // 新增
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '新增NFC视频'
      this.form = {
        id: null,
        name: '',
        modeId: '',
        sn: '',
        url: ''
      }
      this.dialogVisible = true
    },
    // 编辑
    handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '编辑NFC视频'
      this.form = {
        id: row.id,
        name: row.name,
        modeId: row.modeId,
        url: row.url,
        code: row.code,
        sn: row.sn
      }
      this.dialogVisible = true
    },
    // 删除
    handleDelete(row) {
      this.$confirm('确定要删除该NFC视频吗？删除后将同时删除OSS上的视频文件。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await this.$http.delete(`/nfc/video/delete/${row.id}`)
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            this.getList()
          } else {
            this.$message.error(res.data.message || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },
    // 视频上传前校验
    beforeVideoUpload(file) {
      console.log('校验---==--==-=')
      console.log(file.type)
      const isVideo = file.type.startsWith('video/')
      const isGif = file.type == 'image/gif'
      const isLt100M = file.size / 1024 / 1024 < 100

      if (!isVideo && !isGif) {
        this.$message.error('只能上传视频文件/gif动图!')
        return false
      }
      if (!isLt100M) {
        this.$message.error('文件大小不能超过 100MB!')
        return false
      }
      this.videoUploading = true
      return true
    },
    // 视频上传成功
    handleVideoSuccess(response, file, fileList) {
      this.videoUploading = false
      if (response.code === 200) {
        this.form.url = response.data.url
        this.$message.success('视频上传成功')
      } else {
        this.$message.error(response.message || '视频上传失败')
      }
    },
    // 视频上传失败
    handleVideoError(err, file, fileList) {
      this.videoUploading = false
      this.$message.error('视频上传失败')
      console.error('视频上传失败:', err)
    },
    // 删除视频
    removeVideo() {
      this.form.url = ''
    },
    // 提交表单
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return

        this.submitLoading = true
        try {
          const url = this.isEdit ? '/nfc/video/update' : '/nfc/video/add'
          const method = this.isEdit ? 'put' : 'post'
          const res = await this.$http[method](url, this.form)

          if (res.data.code === 200) {
            this.$message.success(this.isEdit ? '更新成功' : '添加成功')
            this.dialogVisible = false
            this.getList()
          } else {
            this.$message.error(res.data.msg || (this.isEdit ? '更新失败' : '添加失败'))
          }
        } catch (error) {
          console.error('提交失败:', error)
          this.$message.error('提交失败')
        } finally {
          this.submitLoading = false
        }
      })
    },
    // 弹窗关闭
    handleDialogClose() {
      this.$refs.formRef && this.$refs.formRef.resetFields()
    }
  }
}
</script>

<style scoped>
.nfc-video-container {
  padding: 20px;
}
.search-box {
  background: #fff;
  padding: 20px 20px 0;
  margin-bottom: 20px;
  border-radius: 4px;
}
.table-box {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}
.el-upload__tip {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
}
</style>
